import { Injectable } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { ApiService, UserService } from '../../index';
import { Http, Response, ResponseType, RequestOptions, ResponseContentType, Headers } from '@angular/http';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';
@Injectable()


export class NhatKyVanHanhService {
  data: any = {};
  datanew: any = {};

  constructor(private router: Router, private api: ApiService,private http:HttpClient) { }
  APIURL = "api/ExcuteOracle";
  APIURL_FILE = "api/Files";

  // uploadMutiFile(desFolder: string, overWrite: string, file: File) {
  //   return this.api.uploadMutiFile(this.APIURL_FILE, desFolder, overWrite, file);
  // }
  //them moi nnhat ký lap dat van hanh
  createNhatKyVanHanhLapDat(chude, tieude, noidung, ngaydang, nguoidang, uploadfile) {
    let curentUser = this.getCurrentUser();
    var param = {
      "config": '{"namesql":"PKG_NHATKY_LAPDAT_VANHANH.P_ADD_NHATKY"}',
      "para": '{"v_id_chude":"' + chude + '","v_tieude":"' + tieude + '","v_noidung":"' + noidung + '","v_ngaydang":"' + ngaydang + '","v_nguoidang":"' + curentUser.mataikhoan + '","v_upload":"' + uploadfile + '"}'
    };
    return this.api.Excute(this.APIURL, param);
  }
    //lay tất cả nhat ky
    GetAll_nhatky() {
      var param = {
        "config": '{"namesql":"PKG_NHATKY_LAPDAT_VANHANH.P_getall"}'
      };
      return this.api.Excute(this.APIURL, param);
    }
  //lay tất cả nhat ky theo chu de
  GetAll_nhatky_By_ChuDe(chude) {
    var param = {
      "config": '{"namesql":"PKG_NHATKY_LAPDAT_VANHANH.P_getall_by_chude"}',
      "para": '{"v_id_chude":"' + chude + '",}'
    };
    return this.api.Excute(this.APIURL, param);
  }
    //lay tất cả nhat ky theo id
    GetAll_nhatky_By_Id(Id) {
      var param = {
        "config": '{"namesql":"PKG_NHATKY_LAPDAT_VANHANH.P_getall_by_id"}',
        "para": '{"v_id":"' + Id + '",}'
      };
      return this.api.Excute(this.APIURL, param);
    }
      //xoa nhat ky
    DELETE_BY_ID(id) {
    var param = {
      "config": '{"namesql":"PKG_NHATKY_LAPDAT_VANHANH.P_DELETE_BY_ID"}',
      "para": '{"v_id":"' + id + '"}'
    };
    return this.api.Excute(this.APIURL, param);
  }
  //lay tai khoan dang dang nhap
  getCurrentUser() {
    let currentUser = JSON.parse(localStorage.getItem("UserInfo"));
    return currentUser;
  }

 

  

}



// WEBPACK FOOTER //
// /media/tranhien/34DCFEAFDCFE6B0E/SourceCode/AMISS4/AMISS4_PC1_LINUX/src/app/services/tien-ich/nhat-ky-van-hanh/nhat-ky-van-hanh.service.ts